import {
  deserializeParameters,
  serializeParameters,
} from "@/lib/parameter-serializer"

/** Parameter names that should be stripped entirely from stored/transmitted XML */
const SENSITIVE_PARAMETER_NAMES = ["Authorization"]

/**
 * Strips sensitive parameters (e.g. Authorization) from parameter XML.
 * Parses the XML, filters out sensitive entries, and re-serializes.
 */
export function sanitizeParameterXml(xml: string): string {
  if (!xml) return xml

  const entries = deserializeParameters(xml)
  const filtered = entries.filter(
    (e) => !SENSITIVE_PARAMETER_NAMES.includes(e.parameterName),
  )
  return serializeParameters(filtered)
}
